import { createRoot, createSignal } from 'solid-js'

// console.log('document.visibilityState === "visible"', document.visibilityState === "visible")
const isDocumentHidden = createRoot(() => {
  const [getIsDocumentHidden, setIsDocumentHidden] = createSignal(document.hidden)

  const handleDocumentVisibilityChange = () => {
    // console.log('handleDocumentVisibilityChange', event)
    setIsDocumentHidden(document.hidden)
  }

  document.addEventListener('visibilitychange', handleDocumentVisibilityChange)

  return getIsDocumentHidden
})

export default isDocumentHidden
